import styled from 'styled-components';

type ContainerProps = {
  color: string;
};
export const Container = styled.td<ContainerProps>`
  width: 10rem;
  height: 88px;
  padding: 0;

  .ContainerMakingNote {
    width: 100%;
    height: 100%;

    textarea {
      padding: 0.3rem;
      width: 90%;
      height: 90%;
      display: flex;
      justify-content: center;
      align-items: center;
      outline: 0;
      resize: none;
      border: 0 !important;
      margin: 0 !important;
      background-color: ${({ color }) => color};
    }
    div {
      display: flex;
      justify-content: center;
      width: 90%;
      outline: 0;
      border: 0 !important;
      margin-top: -1rem;
      padding: 0 !important;
      .cancel {
        color: ${({ theme }) => theme.colors.error_500};
      }
      button {
        width: 100%;
        color: ${({ theme }) => theme.colors.tertiary_500};
        text-decoration: underline;
        font-size: 0.7rem;
        &:nth-child(1) {
          margin-right: 0.1rem;
        }
      }
    }
  }

  button {
    width: 100%;
    height: 100%;
    background-color: ${({ color }) => color};
    outline: 0;
    border: 0 !important;
    margin: 0 !important;
    padding: 0 !important;
  }
`;
